var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.25c-5.523 0-10 3.636-10 8.124 0 1.858.777 3.562 2.066 4.933-.582 1.54-1.793 2.844-1.812 2.858a.94.94 0 0 0 .167 1.429.94.94 0 0 0 .516.154c2.402 0 4.296-1.004 5.433-1.808 1.13.356 2.347.558 3.63.558 5.523 0 10-3.636 10-8.124S17.524 3.25 12 3.25zm0 14.373a10.15 10.15 0 0 1-3.062-.473l-.887-.28-.762.54c-.558.394-1.325.836-2.246 1.133.285-.472.562-1.004.777-1.57l.414-1.097-.805-.852c-.707-.754-1.555-2-1.555-3.648 0-3.445 3.644-6.25 8.124-6.25s8.124 2.805 8.124 6.25-3.644 6.25-8.124 6.25v-.002z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.13424b50fd2b2e9bb47e726e1a9b0e76.svg";
export { ForwardRef as ReactComponent };